export default __webpack_public_path__ + "static/media/compare-icon.d3117f0d.png";